<app-request-details *ngIf="requestId"></app-request-details>

<app-rebate-requests-release-form [isShow]="false" [isOpenedFromReleaseReport]="true"></app-rebate-requests-release-form> 
